import React, { Component } from 'react';

import Box from '../ui/Box';
import { RaisedButton, FlatButton } from 'material-ui';
import TextField from 'material-ui/TextField';

//services
import DataService from '../../services/DataService'; var ds = DataService;

export default class EditSwitch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      switch_appliance: this.props.switch_appliance || {},
      old_name: this.props.switch_appliance ? this.props.switch_appliance.name : '',
    }
  }

  saveSwitch(e) {
    e.preventDefault();
    if (this.state.switch_appliance) {
      ds.postEditSwitch({
        switch_appliance_id: this.state.switch_appliance._id,
        name: this.state.switch_appliance.name
      }, data => {
        this.props.unMountMe();
      }, err => {
        let x = this.state.switch_appliance;
        x.name = this.state.old_name;
        this.setState({
          switch_appliance: x
        })
        this.props.unMountMe();
      })
    }
    else {
      this.props.unMountMe();
    }
  }

  render() {
    return (
      <Box header='Edit Switch'>
        <section>
          <TextField
            floatingLabelText="Switch Name"
            name="cust_name"
            className="w-100"
            value={this.state.switch_appliance.name}
            onChange={(e) => {
              let x = this.state.switch_appliance;
              x.name = e.target.value;
              this.setState({
                switch_appliance: x
              })
            }}
          />
        </section>

        <div className="mt-4vw align-right">
          <RaisedButton
            label="Save"
            primary
            onClick={this.saveSwitch.bind(this)}
            type="button"
          />
          <FlatButton
            label="Cancel"
            primary
            onClick={this.props.unMountMe.bind(this, false)}
            type="button"
          />
        </div>
      </Box>
    )
  }
}


// WEBPACK FOOTER //
// ./components/rooms/EditSwitch.js